<template>
    <div class="translator-redactor">
        <div class="input-group input-group-sm mb-2" v-for="language in languages">
            <div class="input-group-prepend">
                <span class="input-group-text" :title="language.name" v-b-tooltip.hover>
                    <img :src="'/static/flags/4x3/'+ language.key + '.svg'" class="flag-icon" :alt="language.name">
                </span>
            </div>
            <redactor v-model.lazy="values[language.key]"
                      @input="saveTranslate(language.key)"
                      :config="redactorConfig"
            />
        </div>
    </div>
</template>

<script>
    import DataGrid from '../../../core/DataGrid/DataGrid'
    import Redactor from '../../../core/Form/Fields/redactor/RedactorVue';

    export default {
        components: {
            Redactor,
            DataGrid
        },
        props: {
            type: {
                type: String,
                required: true,
            },
            locales: {
                type: Array,
                required: true,
            },
            translateId: {
                type: Number,
                required: true,
            }
        },
        watch: {
            locales() {
                this.initValues();
            }
        },
        mounted() {
            this.initValues();
        },
        computed: {
            languages() {
                return process.env.translator.translatorLanguages[this.type];
            }
        },
        methods: {
            initValues() {
                this.values = {};
                this.locales.forEach(item => {
                    this.values[item.lang] = item.value;
                });
            },
            saveTranslate(locale) {
                this.$store.dispatch('translate/updateTranslate', {
                    translateId: this.translateId,
                    lang: locale,
                    value: this.values[locale],
                });
            }
        },
        data() {
            return {
                values: {},
                redactorConfig: {
                    clickToEdit: true,
                    lang: 'sk',
                    removeNewLines: true,
                    buttons: ['undo', 'redo', 'html', 'format', 'bold', 'italic', 'underline', 'sup', 'sub', 'deleted', 'lists', 'image', 'file', 'link', 'line', 'ol', 'ul', 'indent', 'outdent'],
                    callbacks: {}
                }
            }
        }
    }
</script>
<style lang="scss">
    .translator-redactor {
        .redactor-box {
            position: relative;
            -webkit-box-flex: 1;
            -ms-flex: 1 1 auto;
            flex: 1 1 auto;
            width: 1%;
            margin-bottom: 0;
            border-collapse: collapse;
        }
    }
</style>



// WEBPACK FOOTER //
// src/admin/Pages/StaticText/StaticTextRedactor.vue